/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'edit-assignment-files',
  components: {},
  props: ['updateAssignmentFilesID'],
  data() {
    return {
      section: "",
      file: null,
      name: '',
      description: '',
      submitted: false,
      fileid: '',
      selectedFile: '',
      id: '',
      editSectionFile: '',
      uploadFileName: ''
    }
  },
  computed: {
    ...mapGetters([
      'getAssignmentFilesDetailsState'
    ]),
    editAssignmentFileFun() {
      this.$store.dispatch('getAssignmentFileByIdFun', {
        id: this.updateAssignmentFilesID
      }).then((res) => {
        console.log(this.$store.getters.getAssignmentFilesDetailsState)
        this.name = this.$store.getters.getAssignmentFilesDetailsState.name;
        this.uploadFileName = this.$store.getters.getAssignmentFilesDetailsState.name;
        this.description = this.$store.getters.getAssignmentFilesDetailsState.description;
        this.selectedFile = this.$store.getters.getAssignmentFilesDetailsState.file;
      }).catch((err) => {})
    }
  },
  mounted() {
    this.editAssignmentFileFun
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideUpdateAssignmentFilePopup', false)
      }).catch((err) => {})
    },
    popupCloseFun() {
      bus.$emit('HideUpdateAssignmentFilePopup', false)
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.files = this.$refs.file.files[0];
      this.filesSize = this.$refs.file.files[0].size;
      if (this.$refs.file.files[0].size > 525848) {
        alert('file size is exceed');
        this.name = ''
        this.uploadFileName = ''
      } else {
        this.name = this.files.name
        this.uploadFileName = this.files.name
        console.log(this.name, this.filesSize);
      }
    },
    validateAssignmentBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let formData = new FormData();
          formData.append('description', this.description);
          formData.append('name', this.name);
          if (this.files) {
            formData.append('file', this.files);
          }
          //
          this.$store.dispatch('updateAssignmentFileByID', {
              data: {
                formdata: formData,
                id: this.updateAssignmentFilesID
              }
            })
            .then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success(res.data.msg);
              }
            })
            .catch((err) => {})
          return
        }
      });
    }
  }
}